<template>
    <div class="sticky-top">
        <div class="px-4 py-3 bg-white text-dark shadow">
            <div class="d-flex flex-row align-items-center mx-1 user-select-none">
                <img v-if="store.attributes.logo"
                     :src="store.attributes.logo"
                     :alt="store.attributes.name"
                     class="rounded-sm mr-1"
                     style="max-height: 46px;"
                >
                <div class="flex-grow-1">
                    <div class="py-2 px-4 rounded-sm d-inline-block"
                         :class="{
                        'bg-hover-secondary cursor-pointer': dropdownActive,
                        'cursor-not-allowed': !dropdownActive,
                        'bg-primary text-white': listVisible
                    }"
                         style="background-color: #f4f4f5;"
                         @click="toggleList"
                    >
                        <div class="d-flex gap-5">
                            <div>
                                <div class="font-weight-bold text-black">
                                    {{ store.attributes.name }}
                                </div>
                                <div class="mt-n1 font-size-sm">
                                    <StoreAddress :store="store"/>
                                </div>
                            </div>
                            <Center vertical class="font-size-lg">
                                <a :href="$route('store.edit.basic', [store.id])" class="fas fa-cog"
                                   style="transition-duration: 0s;"/>
                            </Center>
                            <Center vertical class="font-size-lg" v-if="dropdownActive">
                                <i class="fas fa-chevron-down"/>
                            </Center>
                        </div>
                    </div>
                </div>
                <HelpButton />
            </div>
        </div>
        <Transition>
            <div class="position-absolute" v-if="listVisible" @click="listVisible = false"
                 style="top: 0; left: 0; height: 100vh; width: 100vw; background-color: rgba(0,0,0,0.15);">
            </div>
        </Transition>
        <div class="position-absolute mt-n2 ml-1 px-4" style="max-height: 90vh; overflow-y: scroll;" v-if="listVisible">
            <div class="card card-body p-4 rounded-sm shadow-lg d-flex flex-column gap-2">
                <div class="font-weight-bold text-muted">
                    <i class="fas fa-exchange-alt mr-1"/>
                    {{ __('store.change_location') }}
                </div>
                <!--                <input type="text" class="form-control form-control-solid" placeholder="Suchen">-->
                <Link v-for="store in selectableStores"
                      class="btn btn-secondary btn-hover-light-primary rounded-xs p-2 d-flex flex-row gap-4"
                      as="button"
                      :key="store.id"
                      :href="alternativeStoreLink(store)"
                      @click="listVisible = false"
                >
                    <div class="d-flex flex-column justify-content-center">
                        <div class="w-250px text-left py-2">
                            <div class="font-weight-bold">
                                {{ store.attributes.name }}
                            </div>
                            <StoreAddress class="font-size-sm text-left d-block text-truncate"
                                          :store="store"
                                          style="line-height: 1.2em;"/>
                        </div>
                    </div>
                    <StoreImage class="max-h-60px w-100px" :store="store"/>
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import StoreAddress from './StoreAddress.vue';
import StoreImage from './StoreImage.vue';
import Center from '@components/Layout/Center.vue';
import { Link } from '@inertiajs/vue2';
import HelpButton from '@components/HelpButton.vue'

export default {
    components: {
        HelpButton,
        Center,
        StoreImage,
        StoreAddress,
        Link,
    },

    props: {
        store: Object,
        disabled: Boolean,
    },

    data() {
        return {
            listVisible: false,
        };
    },

    methods: {
        toggleList() {
            if (!this.dropdownActive) {
                return;
            }

            this.listVisible = !this.listVisible;
        },

        alternativeStoreLink(newStore) {
            return window.location.href.replace(this.store.id, newStore.id);
        },
    },

    computed: {
        dropdownActive() {
            return this.$page.props.selectableStores !== undefined && this.$page.props.selectableStores.length > 1;
        },

        selectableStores() {
            let stores = [];

            if (this.$page.props.selectableStores !== undefined) {
                for (let store of this.$page.props.selectableStores) {
                    if (store.id !== this.store.id) {
                        stores.push(store);
                    }
                }
            }

            return stores;
        },
    },
};
</script>

<style>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
